import React from 'react';

import { useIntl } from 'ha/i18n';
import { HOME } from 'ha/constants/pageNames';

import { usePage } from 'ha/modules/Page/contexts/PageContext';
import Track from 'ha/components/track/SmartTrack';
import Button from 'ha/ui/next/Button';

export const HowItWorksLink: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { name } = usePage();

  return (
    <Track name="Clicked How It Works in header" type="button">
      <Button
        data-test-locator="How It Works NavBar Btn"
        variant="text"
        color="inherit"
        href={urlResolver.getRenting()}
        rel={name !== HOME ? 'no-follow' : ''}
      >
        {T('how_it_works_breadcrumb')}
      </Button>
    </Track>
  );
};

export default HowItWorksLink;
